import { render, staticRenderFns } from "./UnifiedDiffTable.vue?vue&type=template&id=67d2aa21&scoped=true"
import script from "./UnifiedDiffTable.vue?vue&type=script&lang=js"
export * from "./UnifiedDiffTable.vue?vue&type=script&lang=js"
import style0 from "./UnifiedDiffTable.vue?vue&type=style&index=0&id=67d2aa21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d2aa21",
  null
  
)

export default component.exports